// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"e39ce289f7a968a9","5285":"495b514104d98aa0"}[chunkId] + ".css";
};